var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-left"},[_c('Aside'),_c('div',{staticClass:"line",attrs:{"id":"jDragLine"}})],1),_c('div',{staticClass:"main-right",class:_vm.isAppList ? 'app-list' : ''},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }